<template>
  <div class="app_some">
    <a
      href="https://apps.apple.com/developer/christoph-gogolin/id511901280"
      target="_blank"
    >
      <img
        class="apple somecion"
        alt="Gogolith on the AppStore"
        src="assets/icon-apple.png"
      />
    </a>

    <a href="https://www.instagram.com/gogolith/" target="_blank">
      <img
        class="insta somecion"
        alt="Gogolith on Intagram"
        src="assets/icon-insta.png"
      />
    </a>

    <a
      href="https://www.facebook.com/people/Gogolith-Media/100093113294202/"
      target="_blank"
    >
      <img
        class="fb somecion"
        alt="Gogolith on Facebook"
        src="assets/icon-facebook.png"
      />
    </a>

    <a href="https://www.youtube.com/@gogolith">
      <img
        class="yt somecion"
        alt="Gogolith on Youtube"
        src="assets/icon-yt.png"
      />
    </a>
  </div>
</template>

<script>
export default {
  name: "SoMe",
  props: {},
  methods: {},
  activated: function () {},
  deactivated: function () {},
  mounted: function () {},
  destroyed: function () {},
};
</script>

<style scoped lang="scss">
.somecion {
  max-width: 30px;
  padding: 10px 5px 0 5px;
  opacity: 0.7;

  &:hover {
    opacity: 1;
  }
}
</style>
